import { Stack, Typography, useTheme } from "@mui/material";
import { FoodsIllustrations, WhiteBox } from "@foodpilot/foods";
import { useTranslation } from "react-i18next";

export const SocialWallHeader = () => {
    const theme = useTheme();
    const { t } = useTranslation();

    return (
        <WhiteBox
            sx={{
                mb: 3,
                p: { xs: 2, md: 3 },
                background: `linear-gradient(135deg, ${theme.palette.primary[50]} 0%, ${theme.palette.common.white} 55%)`,
                border: `1px solid ${theme.palette.primary[100]}`,
            }}
        >
            <Stack direction={{ xs: "column", sm: "row" }} alignItems={{ xs: "flex-start", sm: "center" }} gap={2}>
                <FoodsIllustrations
                    illustration="wavingHand"
                    width={72}
                    height={72}
                    backgroundShape="circle"
                    variant="theme"
                />
                <Stack gap={0.5}>
                    <Typography variant="h5" component="h1">
                        {t("social.wall.title", "Community news feed")}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        {t("social.wall.subtitle", "Ask questions, share best practices, and learn from your peers.")}
                    </Typography>
                </Stack>
            </Stack>
        </WhiteBox>
    );
};
